import React from 'react'
import Organisations from 'components/Organisations/Organisations'
import {
  IOrganisationsConnectedDispatch,
  IOrganisationsConnectedState,
} from './organisationsMapProps'
import { ISearchBarMappedProps } from '../../components/SearchBar/containers/searchBarDecorator'

import { getLocalStorageToken } from 'store/localStorage'
import mutationRemoveOrganisation from 'graphql/mutations/mutationRemoveOrganisation'
import mutationUpdateOrganisation from 'graphql/mutations/mutationUpdateOrganisation'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import * as Sentry from '@sentry/browser'
import {
  removeOrganisation as removeOrganisationType,
  removeOrganisationVariables,
} from 'graphql/mutations/types/removeOrganisation'
import {
  updateOrganisation,
  updateOrganisationVariables,
} from 'graphql/mutations/types/updateOrganisation'
import { useMutation } from "@apollo/client/react";
export interface IOrganisationsProps
  extends
    IOrganisationsConnectedState,
    IOrganisationsConnectedDispatch,
    ISearchBarMappedProps {
  removeOrganisation: (id: number) => void
  updateOrganisationName: (OrganisationId: number, newName: string) => void
}

export interface ICreateOrganisationForm {
  name: string
}

export const ADMIN_ORGANISATIONS_ID = 'organisationsTable'
export const ADMIN_ORGANISATIONS_PAGE_SIZE = 5

const OrganisationsContainerClass: React.FC<any> = (props) => {
  const { t } = useTranslation()
  const [removeOrganisationMutation] = useMutation<
    removeOrganisationType,
    removeOrganisationVariables
  >(mutationRemoveOrganisation, {
    refetchQueries: ['organisationsList', 'adminTerminalsList', 'usersList', 'organisations'],
  })
  const [updateOrganisationMutation] = useMutation<updateOrganisation, updateOrganisationVariables>(
    mutationUpdateOrganisation,
    { refetchQueries: ['organisationsList', 'adminTerminalsList', 'usersList', 'organisations'] },
  )

  const removeOrganisation = async (id: number) => {
    try {
      await removeOrganisationMutation({
        variables: { token: getLocalStorageToken(), id },
      })
      toast.success((t('OrganisationsContainer.organisationRemoved') as string) ?? '')
    } catch (error) {
      Sentry.captureException(error)
      toast.error((t('OrganisationsContainer.organisationRemovedFailed') as string) ?? '')
    }
  }

  const updateOrganisationName = async (OrganisationId: number, newName: string) => {
    try {
      updateOrganisationMutation({
        variables: {
          token: getLocalStorageToken(),
          id: OrganisationId,
          name: newName,
        },
      })
      toast.success((t('OrganisationsContainer.organisationUpdated') as string) ?? '')
    } catch (error) {
      Sentry.captureException(error)
      toast.error((t('OrganisationsContainer.organisationUpdatedFailed') as string) ?? '')
    }
  }

  return <Organisations {...{ ...props, removeOrganisation, updateOrganisationName }} />
}

export const OrganisationsContainer: any = OrganisationsContainerClass
